import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import emojione from 'emojione/lib/js/emojione';
import EmojiDropdown from '../EmojiDropdown/EmojiDropdown';
import PhotoUploader from '../PhotoUploader/PhotoUploader';
import MessageMockup from '../MessageMockup/MessageMockupAsync';
import { TouchScrollable } from 'react-scrolllock';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import styles from './MessageEditor.module.scss';
class MessageEditor extends Component {
    constructor() {
        super();
        this.state = {
            messageText: '',
            messageFront: '',
            image: null,
            isFrontExpanded: false
        };

        this.messages = defineMessages({
            placeholder: {
                id: 'messageEditor.placeholder',
                defaultMessage:
                    'Sem napište text přáníčka. Pokud jej necháte bez textu, pošleme v balíčku prázdné přáníčko.'
            }
        });
    }

    componentDidMount() {
        const message = this.props.message ? this.props.message : '';
        const front = this.props.front ? this.props.front : '';
        const image = this.props.image ? this.props.image : null;
        this.setState({ messageText: message, messageFront: front, image: image, saved: true });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const text = nextProps.message ? nextProps.message : '';
        this.setState({ messageText: text, saved: true });
    }

    isMessageFront() {
        return this.props.messageDesign && this.props.messageDesign.front;
    }

    handleSaveClick = e => {
        const text = this.state.messageText === '' ? null : this.state.messageText;
        const front = this.state.messageFront === '' ? null : this.state.messageFront;
        const image = this.state.image ? this.state.image : null;
        this.props.onSave({ message: text, messageFront: front, messageImage: image });
    };

    handleTextareaChange = e => {
        const newText = emojione.toShort(e.target.value);
        this.setState({ messageText: newText });
    };

    handleTextareaFocus = e => {
        this.setState({ isFrontExpanded: false });
    };

    handleFrontChange = e => {
        this.setState({ messageFront: e.target.value });
    };

    handleFrontFocus = e => {
        this.setState({ isFrontExpanded: true });
    };

    handleEmojiSelect = emoji => {
        const newText = emojione.toShort(`${this.state.messageText} ${emoji.native}`);
        this.setState({ messageText: newText });
    };

    handleImageChange = image => {
        this.setState({ image: image });
    };

    renderFrontEditor() {
        if (!this.isMessageFront()) return null;
        return (
            <div className={styles.front}>
                <h4>
                    <FormattedMessage
                        defaultMessage="Text na přední straně"
                        id={'messageEditor.frontTitle'}
                    />
                </h4>
                <input
                    type={'text'}
                    className={`form-control ${styles.input}`}
                    value={this.state.messageFront}
                    placeholder={this.props.messageDesign.front.defaultText}
                    maxLength={25}
                    onChange={this.handleFrontChange}
                    onFocus={this.handleFrontFocus}
                />
            </div>
        );
    }

    render() {
        const { messageDesign } = this.props;
        const { isFrontExpanded, image, messageFront, messageText } = this.state;

        return (
            <div className={styles.wrapper}>
                <h2 className={styles.title}>
                    <FormattedMessage
                        id="messageDesignPicker.title"
                        defaultMessage="Chcete do balíčku vlastní vzkaz?"
                    />
                </h2>
                <div className={styles.content}>
                    <div className={styles.previewWrapper}>
                        <MessageMockup
                            message={messageText}
                            image={image}
                            messageDesign={messageDesign}
                            front={messageFront}
                            isFrontExpanded={isFrontExpanded}
                        />

                        {this.isMessageFront() && (
                            <button
                                className="btn btn-text btn-sm"
                                onClick={() => {
                                    this.setState({ isFrontExpanded: !isFrontExpanded });
                                }}
                            >
                                <FormattedMessage
                                    defaultMessage="Přepnout strany"
                                    id={'messageEditor.pageSwitch'}
                                />
                            </button>
                        )}
                    </div>

                    <div className={styles.editorWrapper}>
                        {this.renderFrontEditor()}
                        <h4>
                            <FormattedMessage
                                defaultMessage="Text vzkazu"
                                id={'messageEditor.messageTitle'}
                            />
                        </h4>
                        <textarea
                            rows="5"
                            className={`form-control ${styles.textarea}`}
                            placeholder={this.props.intl.formatMessage(this.messages.placeholder)}
                            value={emojione.shortnameToUnicode(this.state.messageText)}
                            onChange={this.handleTextareaChange}
                            onFocus={this.handleTextareaFocus}
                            maxLength="400"
                        />
                        <div className={styles.toolbar}>
                            <div className={styles.remaining}>
                                <FormattedMessage
                                    defaultMessage="Zbývá {characterCount} znaků"
                                    values={{ characterCount: 400 - this.state.messageText.length }}
                                    id={'messageEditor.emaining'}
                                />
                            </div>
                            <div className={styles.buttons}>
                                {messageDesign.isPremium && (
                                    <PhotoUploader
                                        onPhotoUploaded={this.handleImageChange}
                                        uploadedPhoto={image}
                                    />
                                )}
                                <EmojiDropdown onEmojiSelect={this.handleEmojiSelect} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.fixed}>
                    <button className="btn btn-text btn-sm" onClick={this.props.onRemove}>
                        <FormattedMessage
                            defaultMessage="Změnit přáníčko"
                            id={'messageEditor.change'}
                        />
                    </button>
                    <button onClick={this.handleSaveClick} className={'btn btn-confirm btn'}>
                        <FormattedMessage
                            defaultMessage="Uložit přáníčko"
                            id={'messageEditor.save'}
                        />
                    </button>
                </div>
            </div>
        );
    }
}

MessageEditor.defaultProps = { message: '' };

MessageEditor.propTypes = {
    messageDesign: PropTypes.object,
    message: PropTypes.string.isRequired,
    image: PropTypes.string,
    front: PropTypes.string,
    isPremium: PropTypes.bool,
    onSave: PropTypes.func,
    onRemove: PropTypes.func
};

export default injectIntl(MessageEditor);
